import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { CategoryLabelContainer, CategoryIcon, CategoryLabel } from './styled'
import useIntersection from '../../../hooks/useIntersection'

function CategoryHeader({
  category, sectionRef, index, setVisibleCategory,
}) {
  const visible = useIntersection(
    { current: sectionRef },
    { threshold: 0.5, options: { threshold: [0, 0.5, 1] } }
  )

  useEffect(() => {
    setVisibleCategory(index, visible)
  }, [visible])

  // no header necessary for the first category
  if (index === 0) return null
  return (
    <CategoryLabelContainer>
      <CategoryIcon size={40} src={category.icon} alt="" noPlaceholder />
      <CategoryLabel>{category.name}</CategoryLabel>
    </CategoryLabelContainer>
  )
}

CategoryHeader.propTypes = {
  category: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  setVisibleCategory: PropTypes.func.isRequired,
  sectionRef: PropTypes.object,
}

CategoryHeader.defaultProps = {
  sectionRef: null,
}

export default CategoryHeader
